import Glide from '@glidejs/glide'

export default class StorySlider {
    static init() {
        Array.prototype.forEach.call(document.querySelectorAll('.story-slider .glide'), el => {
            new StorySlider(el)
        });
    }

    constructor(el) {
        if (!el) return;
        this.el = el;

        new Glide(this.el).mount();
    }
}
